var React = require('react');

function Basket (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_77","data-name":"Path 77","d":"M23.58,12.892a1.883,1.883,0,0,0-1.4-.688H20.713L15.067,5.083a1.037,1.037,0,0,0-1.434-.209,1.093,1.093,0,0,0-.2,1.466c0,.03.029.03.029.06l4.652,5.8H5.588L10.21,6.4a1.056,1.056,0,0,0-.059-1.466,1,1,0,0,0-1.434.06l-.088.09L2.984,12.233H1.814A1.844,1.844,0,0,0,0,14.088a1.489,1.489,0,0,0,.029.359L2.37,26.5a2.621,2.621,0,0,0,2.574,2.154h14.1A2.621,2.621,0,0,0,21.62,26.5l2.34-12.058A1.885,1.885,0,0,0,23.58,12.892ZM8.952,22.675a1.024,1.024,0,1,1-2.048,0V18.427a1.024,1.024,0,1,1,2.048,0Zm4.067,0a1.024,1.024,0,1,1-2.048,0V18.427a1.024,1.024,0,1,1,2.048,0Zm4.037,0a1.024,1.024,0,1,1-2.048,0V18.427a1.024,1.024,0,1,1,2.048,0Z","transform":"translate(0 -4.659)","fill":"currentColor"}));
}

Basket.defaultProps = {"id":"Icon_Basket","data-name":"Icon/Basket","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Basket;

Basket.default = Basket;
